const CategoryEnum = {
  event: 0,
  exhibit: 1
}

export default CategoryEnum;
